<template>
    <div class="famous-pedia-two">
        <!-- 1. 顶部操作栏 -->
        <web-famous-pedia-top-bar></web-famous-pedia-top-bar>

        <!-- 2. 列表 -->
        <div class="famous-pedia-two-list clearfix">
            <famous-pedia-item
                v-for="itemData in curPediaListData"
                v-bind:key="itemData.id"
                v-bind:itemData="itemData"
                v-bind:itemFunc="clickItem">
            </famous-pedia-item>
        </div>
        <!-- 分页 -->
        <div class="famous-pedia-two-page">
            <span @click="clickPrev">&lt;</span>
            <span v-for="page in curPediaPageArr" 
                v-bind:key="'page'+page" 
                v-bind:class="{'cur': page==curPediaTotalData.nowpage}"
                @click="goToPage(page)">
                {{page != -1 ? page : '...'}}
            </span>
            <span @click="clickNext">&gt;</span>
        </div>
    </div>
</template>

<script>
import WebFamousPediaTopBar from '../../layouts/web/WebFamousPediaTopBar.vue'
import FamousPediaItem from '../../components/famouspedia/FamousPediaItem.vue'
import { CONST_FAMOUS_PEDIA_EDIT_TYPE } from '../../modules/data/base/consts';
import { FAMOUS_DOM } from '../../modules/dom';
import { LOADING_DOM } from '../../modules/dom';
export default {
    name: 'FamousPediaTwo',
    components: { WebFamousPediaTopBar, FamousPediaItem },
    computed: {
        curPediaMenuId() {
            return this.$store.state.famouspedia.curPediaMenuId;
        },
        curPediaListGot() {
            return this.$store.state.famouspedia.curPediaListGot;
        },
        curPediaListData() {
            return this.$store.state.famouspedia.curPediaListData;
        },
        curPediaTotalData() {
            return this.$store.state.famouspedia.curPediaTotalData;
        },
        curPediaPageArr() {
            return this.$store.state.famouspedia.curPediaPageArr;
        }
    },
    data() {
        return {
            locked: false,
            pageLocked: false,
            curPage: 0
        }
    },
    mounted() {
        var me = this;
        this.$store.dispatch('famouspedia/initCurPediaList', {
            curId: this.curPediaMenuId,
            cb: function() {
                FAMOUS_DOM.updateFamouPediaList();
                me.$store.dispatch('famouspedia/initCurPediaPage');
            }
        });
    },
    methods: {
        clickItem(data) {
            var me = this;
            if(this.locked) { return; }
            this.locked = true;
            setTimeout(() => {
                me.locked = false;
            }, 2000);
            LOADING_DOM.showLoading();

            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                fromDetail: false,
                baikeId: data.id,
                baikeType: data.type,
                baikeStatus: data.status,
                sucCb: function(curEditType) {
                    me.locked = false;
                    if(curEditType == CONST_FAMOUS_PEDIA_EDIT_TYPE.read) {
                        setTimeout(() => {
                            me.$router.replace('/famouspediareadweb/' + data.id + '/famouspedia')
                        }, 20);
                    }else {
                        me.$router.replace('/famouspediaedit')
                    }
                    LOADING_DOM.hideLoading();
                },
                failCb: function() {
                    me.locked = false;
                    me.$toast('没有找到这个八字的百科数据');
                    LOADING_DOM.hideLoading();
                }
            });
        },
        // 上一页
        clickPrev() {
            if(this.pageLocked) { return; }
            var nowP = parseInt(this.curPediaTotalData.nowpage);
            var newP = nowP-1 > 1 ? nowP-1 : 1; 
            this.goToPage(newP);
        },
        // 下一页
        clickNext() {
            if(this.pageLocked) { return; }
            var nowP = parseInt(this.curPediaTotalData.nowpage),
                totalP = this.curPediaTotalData.totalpage;
            var newP = nowP<totalP ? nowP+1 : totalP; 
            this.goToPage(newP);
        },
        goToPage(page) {
            if(page == '...') { return; }
            if(this.pageLocked) { return; }
            this.lockPage();
            
            var me = this;
            this.$store.state.famouspedia.curPediaTotalData.nowpage = parseInt(page);
            if(this.curPediaMenuId == 1){
                this.$store.dispatch('famouspedia/updateHotList');
            } else if(this.curPediaMenuId == 2) {
                this.$store.dispatch('famouspedia/updateNewList', {
                    cb: function() {
                        me.$store.dispatch('famouspedia/initCurPediaPage');
                    }
                });
            }
        },
        lockPage() {
            var me = this;
            this.pageLocked = true;
            setTimeout(() => {
                me.pageLocked = false;                
            }, 500);
        }
    }
}
</script>

<style>

</style>